import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-downloads-team',
  templateUrl: './downloads-team.component.html',
  styleUrls: ['../../participants-resources/participants-resources.scss']
})
export class DownloadsTeamComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
